import { containers } from '@ecosystem/newron-design-system';
import { SaleType } from '@models/Products';
import { PERFORMANCE_ANALYSIS_MARKET_CARD_TITLE } from '@pages/Utilities';
import { Periodicity } from '../time-period-selector/PeriodsTypes';
import ExploreTrendsStackChart from '@data-visualization/trends-stack-chart/ExploreTrendsStackChart';
import { ExportExploreTrendsStack } from '@data-visualization/trends-stack-chart/Types';
import { ShareType } from '@utils/pageConfig/Types';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import { SortFieldDisplayProps } from '@components/design/migrated/Table';

export interface PerformanceAnalysisMarketCardProps {
  data: ExportExploreTrendsStack;
  selectedGrowthType?: GrowthTypes;
  selectedPeriodicity: Periodicity;
  currencySymbol: string;
  noResultHandler: () => void;
  noPeriodExistForMulticountry?: boolean;
  selectedSaleType: SaleType;
  selectedAbsoluteType: ShareType;
  stackedChartSortingOrder?: SortFieldDisplayProps;
}

const ExploreTrendsMarketCard: React.FC<PerformanceAnalysisMarketCardProps> = ({
  data,
  selectedGrowthType,
  selectedSaleType,
  noResultHandler,
  noPeriodExistForMulticountry,
  selectedAbsoluteType,
  stackedChartSortingOrder,
}) => {
  const { Card } = containers;

  return (
    <div>
      <Card>
        <Card.Title title={PERFORMANCE_ANALYSIS_MARKET_CARD_TITLE}></Card.Title>
        <ExploreTrendsStackChart
          data={data}
          selectedGrowthType={selectedGrowthType}
          noResultHandler={noResultHandler}
          noPeriodExistForMulticountry={noPeriodExistForMulticountry}
          selectedSaleType={selectedSaleType}
          selectedAbsoluteType={selectedAbsoluteType}
          isMarket={true}
          stackedChartSortingOrder={stackedChartSortingOrder}
        />
      </Card>
    </div>
  );
};

export default ExploreTrendsMarketCard;
